
export default function Empathy() {
  return (
    <section id="about" className="relative py-20 lg:py-28 overflow-hidden bg-[#dce8f5]">
      {/* 背景装飾 */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#c5d9f0]/50 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#b8d4f0]/40 rounded-full blur-3xl -translate-x-1/4 translate-y-1/4"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-6 lg:px-12">
        {/* セクションヘッダー */}
        <div className="text-center mb-12">
          {/* セクションラベル */}
          <div className="inline-flex items-center justify-center px-5 py-2 bg-white rounded-full shadow-sm mb-6">
            <span className="text-[#12335f] font-semibold tracking-wide text-sm">Introduction</span>
          </div>
          
          {/* メインタイトル */}
          <h2 className="text-3xl lg:text-4xl font-bold text-[#12335f] leading-tight">
            「DXに取り組む必要性は理解している。」<br />
            そう感じている方は多いと思います。
          </h2>
        </div>
        
        {/* コンテンツカード */}
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            {/* 左側:テキストコンテンツ */}
            <div className="lg:w-3/5">
              {/* 本文 */}
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <p className="text-base lg:text-lg">
                  しかし、具体的に何から始めればよいのかまでは見えておらず、同じような相談は、これまでにも多く寄せられています。
                </p>
                
                <p className="text-base lg:text-lg">
                  ツールやサービス、事例の情報は数多くあります。<br />
                  調べれば選択肢はいくらでも見つかりますが、それらを自社の業務内容や体制、現在のリソースに照らしたとき、どれが現実的で、どこから着手すべきかを判断するのは簡単ではありません。<br />
                  その結果、検討は進めているものの、最初の一歩を踏み出せないままになっているケースも多いのではないでしょうか。
                </p>
              </div>
              
              {/* 課題・効果カード */}
              <div className="mt-8 space-y-4">
                {/* 課題 */}
                <div className="flex items-start gap-4 p-5 bg-[#f0f4f8] rounded-xl">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm">
                    <i className="ri-file-list-3-line text-xl text-[#12335f]"></i>
                  </div>
                  <div>
                    <span className="text-[#12335f] font-bold text-sm block mb-1">よくある課題</span>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      DX推進の必要性は理解しているが、何から始めればよいかわからない。情報は多いが、自社に合った選択肢を判断するのが難しい。
                    </p>
                  </div>
                </div>
                
                {/* 効果 */}
                <div className="flex items-start gap-4 p-5 bg-[#f0f4f8] rounded-xl">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm">
                    <i className="ri-line-chart-line text-xl text-[#12335f]"></i>
                  </div>
                  <div>
                    <span className="text-[#12335f] font-bold text-sm block mb-1">デジポップブーストの解決策</span>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      伴走型支援により、自社の状況に合わせた最適なDX推進プランを策定。段階的なアプローチで確実に成果を実現。
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 右側:画像 */}
            <div className="lg:w-2/5 flex flex-col gap-4">
              {/* メイン画像 */}
              <div className="relative flex-1 min-h-[200px] lg:min-h-0 rounded-xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/a52a13a88e2ccb39325c6dcb34729469/c7a7e9b9956b99f859b2b8e4e95528bb.png"
                  alt="チームミーティング"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              {/* サブ画像 */}
              <div className="relative h-48 rounded-xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/05535b65-957e-4280-8332-f3740a7df8b6.png"
                  alt="コンサルタント"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
